export const FARM_LIST = '/api/property/';
export const SEND_SMS_CARRIER = '/api/carrier/{carrierId}/sms';
export const SEND_SMS_FARM = '/api/property/{propertyId}/sms';
export const UPDATE_FARM = '/api/property/';
export const SEND_SMS_MULTI_FARM = '/api/property/sms-bulk';
